import api from './api';
import * as consts from '../../utils/constants/url';

const tenantApi = api.injectEndpoints({
  endpoints: build => ({
    getProfile: build.query({
      query: () => `${consts.API_TENANT}?include=profile`,
      transformResponse: response => response.data,
    }),
    register: build.mutation({
      query(body = {}) {
        return {
          url: consts.API_REGISTER,
          method: 'POST',
          body,
        };
      },
      transformErrorResponse: response => ({
        status: response.status,
        errors: response.data.errors,
      }),
    }),
  }),
});

export const {useRegisterMutation, useGetProfileQuery} = tenantApi;

export default tenantApi;
